import { FormBase } from "core/components";

export default class FacilityOrderTemplateNewPatientNewFlowCreateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "subCategoryId",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.SUB_CATEGORY_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.SUB_CATEGORY_PLACEHOLDER",
                    rules: "required|string",
                }
            ],
        };
    }
}